/**
 * @description B端商业化联系销售容器
 * @author liushuai
 */

import { WhitePaperBanner } from './components/@whitePaperBanner/whitePaperBanner';
import { WhitePaperContent } from './components/@whitePaperContent/whitePaperContent';
import './whitePaper.scss';

interface IProp {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
    hasSubmitted: boolean;
    changeHasSubmitted: (hasSubmitted: boolean) => void;
}
export const WhitePaper = (props: IProp) => {
    return (
        <div className="white-paper">
            <WhitePaperBanner {...props} />
            <WhitePaperContent {...props} />
        </div>
    );
};
